import { requireById } from './dom'

const TOAST_DELAY = 3400

let toastTimer = 0

/** Bottom-of-frame toast, shared by every view of the operator app. */
export function showToast(message: string): void {
  const toast = requireById('apptoast')
  toast.textContent = message
  toast.classList.add('show')
  window.clearTimeout(toastTimer)
  toastTimer = window.setTimeout(() => toast.classList.remove('show'), TOAST_DELAY)
}

/**
 * Hover/focus tooltip for the analytics marks, positioned inside the app
 * frame. Tooltips enhance only — every value is also directly labelled.
 */
export function showTip(anchor: Element, text: string): void {
  const tip = requireById('apptip')
  const main = requireById('appmain')
  tip.textContent = text
  tip.classList.add('show')
  const a = anchor.getBoundingClientRect()
  const m = main.getBoundingClientRect()
  tip.style.left = `${Math.round(a.left - m.left + a.width / 2)}px`
  tip.style.top = `${Math.round(a.top - m.top)}px`
}

export function hideTip(): void {
  requireById('apptip').classList.remove('show')
}
